export default __webpack_public_path__ + "static/media/copy_icon.c19cb166.svg";